import { queryClient } from '../queryClient'
import { Profile } from './views'

export const QueryKeys = {
  me: queryClient.queryKey<Profile>(['me']),
  options: queryClient.queryKey(['options']),
  create: queryClient.queryKey(['createProfile']),
  update: queryClient.queryKey(['updateProfile']),
}
